module.exports = __webpack_public_path__ + "static/media/marron.8f2d1b66.png";